import React from 'react'
import { Skeleton, Stack } from '@mui/material';

export const CuestionarioSkeleton = () => {
    return (
        <>
            <Stack
                direction={{xs: 'column', sm: 'column', md:'row'}}
                justifyContent="center"
                alignItems="center"
                spacing={1}
                sx={{
                    width: 'calc(100%)'
                }}
            >   
                <Skeleton variant='rectangular' width={400} height={360} animation="wave" />
                <Skeleton variant='rectangular' width={400} height={360} animation="wave" />
                <Skeleton variant='rectangular' width={400} height={360} animation="wave" />
            </Stack>
        </>
    )
}
